import * as React from 'react'
import UserService from "../../services/User";
import {notification,Input} from "antd";
import {UserOutlined,LockOutlined,} from "@ant-design/icons";
import { settingStore } from '../../stores/Settings';
import {observer} from "mobx-react";
require('./Login.less');
export default 
@observer class Login extends React.Component {

    constructor(props) {
        super(props);
        this.username = React.createRef();
        this.password = React.createRef();
    }

    handleOk = (e) => {
        e.preventDefault();
        console.log("handleOk",e);
        const username = document.getElementById("username").value;
        const password = document.getElementById("password").value;
        this.login(username, password);
        return false;//不要刷新页面
    };

    login = (username, password) => {
        //服务端判断
        UserService.login(username, password).then((user) => {
            // if(username===password){
            //     notification.warn({message:'完善信息',description:'用户名密码一致，请先修改/完善个人信息'});
            //     window.location.hash = "#/change_info";
            //     return
            // }
            this.checkInfoNotification();
            window.location.hash = "#/";
        }).catch(e=>{
            return  notification.warn({message:"登录失败",description:"无效的账号/密码"})
        })
    };

    checkInfoNotification= async () => {
        const user = UserService.getCurrentUser();
        if(!user.isAdmin&&!user.isTeacher){
            const isOpenClassName = window.config.is_open_classname;
            const isOpenMsg = window.config.is_open_msg;
            var content = "";
            if(isOpenMsg===true&&(!user.phone||user.phone.trim().length==0)){
                content += "手机号"
            }
            if(isOpenClassName===true&&(!user.class_name||user.class_name.trim().length==0)){
                if(content.length>0){
                    content += "、"
                }
                content += "班级"
            }
            if(content.length>0){
                notification.open({message: '完善信息', description: content+'为空，请完善个人信息',onClick: () => {
                        window.location.hash = "#/change_info";
                    }});
            }
        }
    };

    render() {
        const APPID="wx181cdcdcb1c9bbcb";
        const REDIRECT_URI=encodeURIComponent("http://wechat.jiaozuoye.online/wechat_login_callback.html");
        const STATE=encodeURIComponent(window.config.domain+"/#/wechat_login_callback/");
        const wechat_login_url=`https://open.weixin.qq.com/connect/qrconnect?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_login&state=${STATE}#wechat_redirect`;
        var usernamePlaceholder = "用户名/手机号";
        if(window.config.college==='南京邮电大学'){
            usernamePlaceholder = '用户名';
        }
        const hide = window.config.hideRecord;
        const {name,logo}=settingStore;
        return (
            <div className='login'>
                {hide?null:<div className='title'>
                    {/*<img src={config.login_logo} className='slogo'/>*/}
                    <span className='sname'>{name||window.config.name}</span>
                </div>}
                <div className={hide?"card_lgd":'card'}>
                   { hide?<div className='logo' >
                        {name||window.config.name}
                    </div>:<div className='logo'>
                        <img src={logo||window.config.login_logo}/>
                        <span className='text'>登录</span>
                    </div>}
                    <form onSubmit={this.handleOk}>
                        <div className="form-item">
                            {/* <i className="icon iconfont icon-yonghuming" style={{color: "rgb(32, 149, 188)"}}></i> */}
                            {/* <input placeholder={usernamePlaceholder} ref={this.username} id="username"
                                   className="ant-input ant-input-lg"/> */}
                                   <Input size="large"   placeholder={usernamePlaceholder} ref={this.username} id="username" prefix={<UserOutlined />} />
                        </div>
                        <div className="form-item">
                            {/* <i className="icon iconfont icon-mima" style={{color: "rgb(32, 149, 188)"}}></i> */}

                                   <Input type="password" ref={this.password} placeholder="密码"  id="password"prefix={<LockOutlined />} />   
                        </div>
                        {hide?null:<a href="#/mobile_login" style={{float:"right"}}>使用短信验证码登录</a>}
                        <button type="submit" className="form-item">
                            <span>登 录</span>
                        </button>
                        {hide?null:<div className={'register'}>
                            <a href={wechat_login_url}>微信登录/注册</a>
                        </div>}
                    </form>
                    <br />
                    {hide?null:<div className='text'>
                    未注册的手机号，我们将自动帮你注册账号
                    <br />
                    登录或完成注册即代表你同意<a href='https://dazn6y43dtn.feishu.cn/wiki/Gc2iwtyQGi3eXbkg0YJclK0mn9d?from=from_copylink'>《用户协议》</a>和<a href='https://dazn6y43dtn.feishu.cn/wiki/OF5Pwz9NmiFIqRk7pVacD259nRg?from=from_copylink'>《隐私政策》</a>
                    </div>}
                </div>
               
                {hide?<div div className='footer'>{window.config.text}</div>:<div className='footer'>©copyright 2019 Limsolution Corporation. 南京凌速科技有限公司
                    版权所有.<a style={{color:'#ffffff'}} href="https://beian.miit.gov.cn/">苏ICP备09069895号-13</a>
                </div>}
            </div>
        )
    }
}


